/** Expenses and advances (English skeleton; missing keys fall back to Turkish). */
export const expenses = {
  status: {
    draft: "Draft – not submitted yet",
    pending_manager: "Waiting for your manager's approval",
    pending_manager_viewer: "Waiting for manager approval",
    pending_finance: "Waiting for finance approval",
    pending_management: "Waiting for company management approval",
    returned: "Waiting for your corrections",
    returned_viewer: "Waiting for the employee's corrections",
    approved: "Approved – waiting for payment",
    paid: "Paid ({date})",
    rejected: "Rejected",
    cancelled: "Cancelled",
  },
  advanceStatus: {
    pending_manager: "Waiting for your manager's approval",
    pending_manager_viewer: "Waiting for manager approval",
    pending_finance: "Waiting for finance approval",
    pending_management: "Waiting for company management approval",
    approved: "Approved – waiting for payment",
    paid: "Paid ({date}) – waiting to be settled",
    settled: "Settled ({date})",
    rejected: "Rejected",
    cancelled: "Cancelled",
  },
  approver: {
    manager: "Manager",
    finance: "Finance team",
    management: "Company management (instead of finance)",
  },
  waiting: {
    person: "Waiting for {name}",
    finance: "Waiting for the finance team",
    management: "Waiting for the general manager or the HR manager",
    finance_payment: "Waiting for the finance team to pay",
    you_submit: "Add your items and submit",
    you_fix: "Read the note, make corrections and resubmit",
    employee_fix: "Waiting for {name} to correct it",
    you_settle: "Report your spending with an expense claim linked to this advance",
    employee_settle: "Waiting for an expense claim from {name}",
    linked_claim: "Will be settled automatically when the expense claim “{title}” is paid",
  },
  timeline: {
    created: "Draft created",
    submitted: "Submitted for approval",
    resubmitted: "Corrected and resubmitted",
    approved_step: "{name} approved",
    approved_step_delegate: "{name} approved on behalf of {forName}",
    rejected: "{name} rejected",
    returned: "{name} sent it back for corrections",
    paid: "{name} marked it as paid ({date})",
    cancelled: "Cancelled",
    rerouted: "Approver changed: now waiting for {name}",
    skipped_no_manager: "No manager assigned, so approval moved to the finance team",
    settled_claim: "Settled against the expense claim “{title}”",
    settled_note: "Settled by {name}",
    advance_requested: "Advance requested",
  },
};
